module.exports = __webpack_public_path__ + "static/media/CloudIcon.62d6ca23.svg";